module.exports = __webpack_public_path__ + "8a6a5ae183fb4486b2f2aec13e617dc0.svg";